import React from 'react'
import { PageSection as Section, Grid } from '@superhi/design'

import GetCourseSyllabus from './components/GetCourseSyllabus'
import SyllabusProjectsProjectImage from './components/SyllabusProjectImage'
import SyllabusProjectsProjectVideo from './components/SyllabusProjectVideo'
import SyllabusProjectImage from './components/SyllabusProjectImage'
import SyllabusProjectVideo from './components/SyllabusProjectVideo'

export const ID = 'SYLLABUS'

type Props = {
  syllabusUrl: string
  courseMailchimpTag: string
  emailModalImageUrl: string
  chapters: (
    | React.ComponentProps<typeof SyllabusProjectImage>
    | React.ComponentProps<typeof SyllabusProjectVideo>
  )[]
} & Pick<React.ComponentProps<typeof Section>, 'noTopPadding'>

const GRID_1_ROW_GAP = { small: 32, medium: 40, large: 48, xlarge: 48 }
const GRID_1_CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: 6,
  xlarge: 6,
}

const Syllabus: React.FC<React.PropsWithChildren<Props>> = ({
  syllabusUrl,
  courseMailchimpTag,
  emailModalImageUrl,
  noTopPadding,
  chapters = [],
}) => (
  <Section
    id={ID}
    title="Syllabus"
    // subtitle="Here's a breakdown of everything you'll learn on the course."
    // decorationName="pentagon"
    // decorationPosition="bottom-right"
    noTopPadding={noTopPadding}
    headingLevel={2}
    footer={
      <GetCourseSyllabus
        syllabusUrl={syllabusUrl}
        courseMailchimpTag={courseMailchimpTag}
        emailModalImageUrl={emailModalImageUrl}
      />
    }
  >
    <Grid rowGap={GRID_1_ROW_GAP}>
      {chapters.map((chapter, i): React.ReactElement => {
        switch (chapter.__typename) {
          case 'ProductCourseProjectImage': {
            return (
              <Grid.Cell key={i} span={GRID_1_CELL_SPAN_2}>
                <SyllabusProjectsProjectImage {...chapter} />
              </Grid.Cell>
            )
          }
          case 'ProductCourseProjectVideo': {
            return (
              <Grid.Cell key={i} span={GRID_1_CELL_SPAN_2}>
                <SyllabusProjectsProjectVideo {...chapter} />
              </Grid.Cell>
            )
          }
        }
      })}
    </Grid>
  </Section>
)

export default Syllabus
